<template>
  <div class="lv-state-member-input-item">
    <p class="lv-state-member-input-item_number">
      {{ _memberIndex }}
    </p>
    <div class="name-input">
      <StateInputButton
        v-model="memberData.name"
        required
        leading-icon="icon-outline-perm-identity"
        rules="required"
      />
    </div>
    <div class="email-input">
      <StateInputButton
        v-model="memberData.email"
        required
        leading-icon="icon-email"
        rules="required|email"
      />
    </div>
    <LvTooltipButton
      icon="icon-delete"
      red
      background
      @click="$_onDelete()"
    />
  </div>
</template>
<script>
export default {
  name: "LvStateMemberInputItem",
  props: {
    value: {
      type: Object,
      default() {
        return {};
      },
    },
    number: {
      type: Number,
      default: 0,
    },
  },
  data: () => ({
    memberData: {
      name: "",
      email: "",
    },
  }),
  computed: {
    _memberIndex() {
      if (this.number < 10) {
        return "0" + this.number;
      }
      return this.number;
    },
  },
  watch: {
    value() {
      this.memberData.name = this.value.name;
      this.memberData.email = this.value.email;
    },
    memberData: {
      handler() {
        this.$emit("input", this.memberData);
      },
      deep: true
    }
  },
  mounted() {
    this.memberData.name = this.value.name;
    this.memberData.email = this.value.email;
  },
  methods: {
    $_onDelete() {
      this.$emit("delete");
    },
  },
};
</script>